export const SUMMARY_LABELS = {
  SUBSCRIPTION_PHONE_LICENSES: "Phone Licenses You Have",
  UNALLOCATED_PHONE_LICENSES: "Unallocated Phone Licenses",
  REQUIRED_PHONE_LICENSES: "Minimum Additional Required Phone Licenses"
};


export const HEADER_LABELS = {
  HEADER_TITLE: "Microsoft Teams License Checker"
}